<template>

<div class="page work">

  <!-- MAIN LANDING SECTION -->
	<transition name="slide-up-in" appear>
	<section id="landing" class="block-image-hero">
		<div class="container">
			<span class="hero-background"></span>
			<ts-image :src="image1.url" :width="image1.size[0]" :height="image1.size[1]" :bg-color="image1.bgColor"></ts-image>
		</div>
	</section>
	</transition>

	<!-- TEXT -->
	<section id="section-1" class="block-text-overview">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-5" data-sal="slide-up" data-sal-delay="600" data-sal-duration="600" data-sal-easing="ease">
					<p class="meta">UX &amp; UI</p>
					<h2>The Coaching Manual</h2>
					<p>The Coaching Manual is an education platform tool that bridges the gap between professional and grassroots level coaching.</p>
					<p>I worked closely with The Coaching Manual to evolve upon the initial brand concept and deliver a platform that supports creating, managing and sharing content simple.</p>
					<p>We built from the ground up a comprehensive coaching platform that allows collaborative learning to thrive. Users can organise content, plan seasons, create or download training sessions and even interact with professional coaches.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGE -->
	<section id="section-2" class="block-image" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
		<div class="container">
			<!-- IMAGE 2 -->
			<ts-image :src="image2.url" :width="image2.size[0]" :height="image2.size[1]" :bg-color="image2.bgColor" dark-loader></ts-image>
		</div>
	</section>


	<!-- TEXT -->
	<section id="section-3" class="block-text-content border">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Grouping Information</br>Into Content Groups</h3>
					<p>When a user enters the platform for the first time, it’s easy to be overwhelmed by a significant amount of content, especially when produced at a rapid rate.</p>
					<p>The information is broken into clear information groups and created a tone of voice that sounds familiar to football coaches and players. </p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGES -->
	<section id="section-4" class="block-image multiple">
		<div class="container">
			<span class="background right"></span>
			<!-- IMAGE 3 -->
			<ts-image :src="image3.url" :width="image3.size[0]" :height="image3.size[1]" :bg-color="image3.bgColor"></ts-image>
			<!-- IMAGE 4 -->
			<ts-image :src="image4.url" :width="image4.size[0]" :height="image4.size[1]" :bg-color="image4.bgColor"></ts-image>
			<!-- IMAGE 5 -->
			<ts-image :src="image5.url" :width="image5.size[0]" :height="image5.size[1]" :bg-color="image5.bgColor"></ts-image>
			<!-- IMAGE 6 -->
			<ts-image :src="image6.url" :width="image6.size[0]" :height="image6.size[1]" :bg-color="image6.bgColor"></ts-image>
		</div>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


	<!-- TEXT -->
	<section id="section-5" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Club &amp; Team Management</h3>
					<p>There are many types of learning methods, and one that The Coaching Manual platform deploys the most is collaborative learning.</p>
					<p>The Club and Team integration help make collaborative learning easier. Users can curate skill and article content for their players as well as learning from professionals from other clubs.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGE -->
	<section id="section-6" class="block-image">
		<div class="container">
			<span class="background left"></span>
			<!-- IMAGE 7 -->
			<ts-image :src="image7.url" :width="image7.size[0]" :height="image7.size[1]" :bg-color="image7.bgColor"></ts-image>
		</div>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


	<!-- TEXT -->
	<section id="section-7" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Decoding Content By Skill</h3>
					<p>A part of evolving the brand was to create a simple visual language that when learned for the first time, made scanning and searching for content more convenient.</p>
					<p>I developed a colour coding scheme, combined with an intelligent tagging system, that shows how much of the content is made up of goalkeeping, defending, attacking or fundamental skills.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGE -->
	<section id="section-8" class="block-image full">
		<!-- IMAGE 8 -->
		<ts-image :src="image8.url" :width="image8.size[0]" :height="image8.size[1]" :bg-color="image8.bgColor"></ts-image>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


	<!-- TEXT CONTENT -->
	<section id="section-9" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h3>Organising &amp; Sharing Content</h3>
					<p>When the user searches through the extensive catalogue of skill videos or articles, saving and organising content can be accessed anywhere on the platform.</p>
					<p>Users can also share content within clubs and save for later to further refine training plans and season schedules.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGES -->
	<section id="section-10" class="block-image multiple">
		<div class="container">
			<span class="background right"></span>
			<!-- IMAGE 9 -->
			<ts-image :src="image9.url" :width="image9.size[0]" :height="image9.size[1]" :bg-color="image9.bgColor"></ts-image>
			<!-- IMAGE 10 -->
			<ts-image :src="image10.url" :width="image10.size[0]" :height="image10.size[1]" :bg-color="image10.bgColor"></ts-image>
		</div>
	</section>

	<ts-footer></ts-footer>

</div>


</template>


<script>

// @ is an alias to /src
import sal from 'sal.js'
import TsImage from '@/components/TSImage.vue'
import TsFooter from '@/components/TSFooter.vue'

import Image1 from "@/assets/images/works/thecoachingmanual/100-image-1.png"
import Image2 from "@/assets/images/works/thecoachingmanual/100-image-2.png"
import Image3 from "@/assets/images/works/thecoachingmanual/100-image-3.png"
import Image4 from "@/assets/images/works/thecoachingmanual/100-image-4.png"
import Image5 from "@/assets/images/works/thecoachingmanual/100-image-5.png"
import Image6 from "@/assets/images/works/thecoachingmanual/100-image-6.png"
import Image7 from "@/assets/images/works/thecoachingmanual/100-image-7.png"
import Image8 from "@/assets/images/works/thecoachingmanual/100-image-8.png"
import Image9 from "@/assets/images/works/thecoachingmanual/100-image-9.png"
import Image10 from "@/assets/images/works/thecoachingmanual/100-image-10.png"

export default {

  name: 'WorksTheCoachingManual',

  data() {
    return {
      image1: {
				url: Image1,
				size: [2564,1358],
				bgColor: "none"
			},
      image2: {
				url: Image2,
				size: [2560,1696],
				bgColor: "none"
			},
      image3: {
				url: Image3,
				size: [2560,1560],
				bgColor: "none"
			},
      image4: {
				url: Image4,
				size: [2560,2592],
				bgColor: "none"
			},
      image5: {
				url: Image5,
				size: [2560,2072],
				bgColor: "none"
			},
      image6: {
				url: Image6,
				size: [2560,1560],
				bgColor: "none"
			},
      image7: {
				url: Image7,
				size: [2560,1560],
				bgColor: "none"
			},
      image8: {
				url: Image8,
				size: [2880,3306],
				bgColor: "none"
			},
      image9: {
				url: Image9,
				size: [2560,1560],
				bgColor: "none"
			},
      image10: {
				url: Image10,
				size: [2560,3746],
				bgColor: "none"
			}
    }
  },

  components: {
    TsImage,
		TsFooter
  },

	mounted() {
    this.$root.$emit('show-shapes', false)
		sal({threshold: 0.10});
  }

}

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

@import "~@/assets/scss/_variables";
@import "~@/assets/scss/grid/_bootstrap-grid";

span.hero-background {
	background-color: #1AD36B;
	background-image: url(/assets/images/works/thecoachingmanual/100-image-1-BG.png);
	background-size: cover;
	// background-image: radial-gradient(50% 100%, #1AD36B 0%, #00DB58 100%);
}
span.background {
	background-color: #1AD36B;
	background-image: radial-gradient(50% 100%, #1AD36B 0%, #00DB58 100%);
}

</style>
